import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import tableHomeConfigs from './formGroupLiveApps/tableHomeConfigs';
import tableMainhubConfig from './tableMainhubConfig';

export default {
  title: 'Configs',
  attributeName: 'mainHubConfig',
  fields: [
     {
      attributeName: 'mainHubConfig',
      type: FormInputTypes.TABLECOMPONENT,
      // mode:'POPUP',
      helpText: '',
      configFile: tableHomeConfigs,
  // sessionParams: ['mainHubId'],

    },
   
  ],
};
